import React, { FunctionComponent } from 'react';
import {
  Card,
  CardContent,
  IconButton,
  Stack,
  SxProps,
  Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface TableSelectedActionsProps {
  selectedList: string[];
  clearSelected: () => void;
  actionsElement?: JSX.Element;
}

const containerStyles: SxProps = {
  border: '1px solid #E2E8F0',
  borderRadius: '12px',
};

const TableSelectedActions: FunctionComponent<TableSelectedActionsProps> = ({
  selectedList,
  actionsElement = null,
  clearSelected,
}) => {
  const selectedListLength = selectedList.length;

  return (
    <div style={{ padding: '0 20px 20px 20px' }}>
      <Card elevation={0} sx={containerStyles}>
        <CardContent style={{ padding: '16px' }}>
          <Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="subtitle2" fontWeight={600}>
                {selectedListLength} row{selectedListLength > 1 ? 's' : null}{' '}
                selected
              </Typography>
              <IconButton onClick={clearSelected}>
                <CloseIcon />
              </IconButton>
            </Stack>
            {actionsElement}
          </Stack>
        </CardContent>
      </Card>
    </div>
  );
};

export default TableSelectedActions;
